<app-tsp-admin-menu></app-tsp-admin-menu>
<main class="scrollbar-gray">
  <router-outlet></router-outlet>
</main>
<p-toast [class]="'inline'"></p-toast>
